import { FileExcelOutlined } from "@ant-design/icons";
import { Input, message, notification, Tooltip } from "antd";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import Modal from "antd/lib/modal/Modal";
import Dragger from "antd/lib/upload/Dragger";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import { ENV } from "../../Infrastructure/EnvironmentConfig";
import TargetStore from "../productiontarget/store/TargetStore";
const targetstore = createContext(TargetStore);
const _ = require("underscore");
export const TargetUploadDialog = observer(() => {
  const targetStore = useContext(targetstore);
  const uploadprops = {
    name: "file",
    accept: ".xls,.xlsx",
    multiple: false,
    beforeUpload: (file, fileList) => {
      if (_.isEmpty(targetStore.sheetName)) {
        notification.error({
          key: "error",
          message: "SPARS Feedback",
          description:
            "input deck sheet name is required,enter the flash production report sheetname",
        });

        return false;
      }
      return true;
    },
    headers: {
      method: "Post",
    },
    data: "newtemplate",
    action: `${ENV.API_ROOT}/Target/ImportTarget?sheetname=${targetStore.sheetName}&year=${targetStore.targetYear}`,

    onChange(info) {
      const { status } = info.file;
      /* if (status !== "uploading") {
        console.log(info.file, info.fileList);
      } */
      if (status === "done") {
        const { status } = info.file.response;

        if (!status) {
          notification.error({
            message: "SPARS Feedback",
            description: info.file.response.message,
          });
        } else {
          const { data } = info.file.response;

          targetStore.importedTargets = data;
        }
      } else if (status === "error") {
        message.error(
          `${info.file.name} file preview failed due to ${info.file.response}`
        );
      }
    },
  };
  return (
    <Modal
      title={`${targetStore.mainStore.assetContextName}-OANDO Poduction and Evacuation Targets for ${targetStore.targetYear} Upload`}
      centered
      visible={targetStore.showTargetDialog}
      onOk={() => {
        targetStore.hasImported = true;
        targetStore.showTargetDialog = false;
      }}
      onCancel={() => {
        targetStore.showTargetDialog = false;
      }}
      okText="Preview"
      okButtonProps={{ disabled: !targetStore.importHasRows }}
      cancelText="Cancel"
      width={600}
    >
      <Form layout="vertical">
        <FormItem
          label={
            <span style={{ color: "red" }}>Yearly Target WorkSheet Name *</span>
          }
        >
          <Tooltip title="enter the sheetname where the yearly production and evacuation targets is located in the browsed workbook">
            <Input
              placeholder="Worksheet Name"
              value={targetStore.sheetName}
              defaultValue="Targets"
              onChange={({ target }) => {
                targetStore.sheetName = target.value;
              }}
            />
          </Tooltip>
        </FormItem>
        <Dragger
          style={{
            width: "100%",
            backgroundColor: "F7FAFC",
          }}
          multiple={false}
          {...uploadprops}
        >
          <p className="ant-upload-drag-icon">
            <FileExcelOutlined style={{ color: "#68D391" }} />
          </p>
          <p className="ant-upload-text">
            Browse poduction and evacuation targets
          </p>
        </Dragger>
      </Form>
    </Modal>
  );
});

